import { ClientLogger } from "bernie-client";
import { SystemEvent, SystemEventLevel } from "bernie-logger";
const LOGGER = ClientLogger.getLoggerWithIdentifier("Meso3AnalyticsUtils");

/**
 * INFO-level SystemEvents
 * @type {SystemEvent}
 */
 export const TRACK_EVENT = new SystemEvent(SystemEventLevel.INFO, "TRACK_EVENT");

// Enum to describe actions for tracking purposes which follow the MESO3 standards
export enum Action {
    CLICK = "click",
    IMPRESSION = "impression",
    BACK_BUTTON = "back-button",
    SCROLL = "scroll",
  }

// Generic interface to ensure consistent MESO3 tracking info when sending a track event
export interface FlexTrackingInfo {
    moduleName: string | null;
    action: Action | null;
    rfrr?: string;
    linkName?: string;
    mcicid?: string;
  }
  

/**
 * Builds an appropriate and consistent rfrr id that follows the MESO3 standards
 * @param {FlexTrackingInfo} flexTrackingInfo
 * @returns {string}
 */
 export const buildFlexRfrrId = (flexTrackingInfo: FlexTrackingInfo): string => {
    if (!flexTrackingInfo?.action || !flexTrackingInfo.moduleName) {
      return "unknown";
    }
  
    const { rfrr, moduleName, action } = flexTrackingInfo;
  
    return rfrr ? `${moduleName}.${rfrr}.${action}` : `${moduleName}.${action}`;
  };

/**
 * Generic logging function to log a track event to Splunk
 * @param {FlexTrackingInfo} flexTrackingInfo
 */
 export const logTrackEventToSplunk = (flexTrackingInfo: FlexTrackingInfo) => {
    LOGGER.logEvent(
      TRACK_EVENT,
      `Received track event: ${Object.keys(flexTrackingInfo)
        .map((key) => `${key}="${flexTrackingInfo[key]}"`)
        .join(" ")}`
    );
  };